import React from 'react';
import ActionPlanList from './ActionPlanList';

const ActionPlanSelection = ({
  loading,
  error,
  items,
  latestEvent,
  selectedIds,
  durationDays,
  onDurationChange,
  onToggleSelect,
  onStartSprint,
  onCompleteManual,
  onUploadProof,
}) => {
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const renderControls = (item) => {
    const ct = item?.task_template?.completion_type;
    if (ct === 'manual') {
      return (
        <button className="btn btn-sm" onClick={() => onCompleteManual(item.id)}>
          Mark Complete
        </button>
      );
    }
    if (ct === 'offline_upload') {
      return (
        <label className="btn btn-sm">
          Upload Proof
          <input type="file" style={{ display: 'none' }} onChange={(e) => {
            const f = e.target.files?.[0];
            if (!f) return;
            // For now, assume a Document has been created elsewhere; this is a placeholder hook.
            // Integrate with existing uploader to obtain a documentId.
            // eslint-disable-next-line no-alert
            alert('Hook your uploader and pass documentId to onUploadProof');
          }} />
        </label>
      );
    }
    if (ct === 'platform_activity') {
      return <span className="text-xs opacity-75">Auto-completes when activity is done</span>;
    }
    return null;
  };

  return (
    <div className="p-4 space-y-4">
      <div>
        <h2 className="text-xl font-semibold">Recommended Action Plan</h2>
        {latestEvent && (
          <div className="text-sm opacity-80">Latest Triggering Event: {latestEvent.event_type} at {new Date(latestEvent.completed_at).toLocaleString()}</div>
        )}
      </div>

      <div className="flex items-center gap-3">
        <label className="text-sm">Sprint Duration (days):</label>
        <input type="number" min={7} max={90} value={durationDays} onChange={(e) => onDurationChange(parseInt(e.target.value || '0', 10))} />
        <button className="btn btn-primary" onClick={onStartSprint} disabled={selectedIds.size === 0}>Start Sprint</button>
      </div>

      <div className="space-y-2">
        {items.map((item) => (
          <div key={item.id} className="border p-3 rounded flex items-start justify-between gap-3">
            <div className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={selectedIds.has(item.id)}
                onChange={() => onToggleSelect(item.id)}
                disabled={item.status === 'completed'}
              />
              <div>
                <div className="font-medium">{item?.task_template?.title}</div>
                <div className="text-sm opacity-80">{item?.task_template?.description}</div>
                <div className="text-xs opacity-70">CEPA: {item.cepa_category} • Type: {item?.task_template?.completion_type}</div>
                {item.created_from_assessment_question && (
                  <div className="text-xs opacity-70">From: {item.created_from_assessment_question.text}</div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs">Status: {item.status}</span>
              {renderControls(item)}
            </div>
          </div>
        ))}
      </div>

      <ActionPlanList
        title="Current Sprint"
        items={(items || []).filter((i) => i.selected_for_sprint)}
      />
    </div>
  );
};

export default ActionPlanSelection;


